// Begin ISH Free Shipping and Tumbler Custom Widgets - Dynamic Update

document.addEventListener('ajaxProduct:added', function(evt) {
  console.log("Updating: Product added", evt.detail)
  updateFreeShippingWidget(evt);
  updateFreeTumblerWidget();
  updateFreeShampooWidget();
  updateFreeSoapWidget();
  updateFreeTravelCaseWidget();

  // Segment Analytics commented out - replaced with Customer Events Pixel:
  // analyticsEvent(evt.detail.product);

  // console.log("Product.id3", evt.detail.product.product_id);
  //   if (typeof analytics == "object"){
  //   console.log("Product Added", product);
  //   analytics.track('Product Added', {
  //       product_id: "",
  //       sku: "",
  //       name: "",
  //       price: "",
  //       quantity: "",
  //       category: ""
  //   });
  // }
});

document.addEventListener('cart:updated', function(evt) {
  console.log("Updating: Cart added", evt.detail)
  updateFreeShippingWidget(evt);
  updateFreeTumblerWidget();
  updateFreeShampooWidget();
  updateFreeSoapWidget();
  updateFreeTravelCaseWidget();
});

function updateFreeShippingWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 10000){
        // Add more for free shipping:
        progressAmount = 10000 - subtotal;
        progressWidth = (10000 - progressAmount) / 100;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE SHIPPING</b>.`;              
      } else {
        // Free shipping achieved!
        progressWidth = 100;
        message = "Your order will ship for FREE!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-shipping .progress-bar");
      const freeShippingTextEls = document.querySelectorAll(".js-free-shipping .js-free-shipping-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeShippingTextEls.length; i++){
        // console.log("Updating text...", message);
        freeShippingTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeTumblerWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;

      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }

      if (subtotal < 10000){
        // Add more for free tumbler:
        progressAmount = 10000 - subtotal;
        progressWidth = (10000 - progressAmount) / 100;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Leftist Tears Tumbler</b>.`;              
      } else {
        // Free tumbler achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Leftist Tears Tumbler!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-tumbler .progress-bar");
      const freeTumblerTextEls = document.querySelectorAll(".js-free-tumbler .js-free-tumbler-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeTumblerTextEls.length; i++){
        // console.log("Updating text...", message);
        freeTumblerTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeChocolateWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 7500){
        // Add more for free chocolate:
        progressAmount = 7500 - subtotal;
        progressWidth = (7500 - progressAmount) / 75;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Chocolate</b>.`;              
      } else {
        // Free Chocolate achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Chocolate Combo Pack!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-chocolate .progress-bar");
      const freeChocolateTextEls = document.querySelectorAll(".js-free-chocolate .js-free-chocolate-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeChocolateTextEls.length; i++){
        // console.log("Updating text...", message);
        freeChocolateTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeShampooWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 5000){
        // Add more for free shampoo:
        progressAmount = 5000 - subtotal;
        progressWidth = (5000 - progressAmount) / 50;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Shampoo</b>.`;              
      } else {
        // Free Shampoo achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Shampoo!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-shampoo .progress-bar");
      const freeShampooTextEls = document.querySelectorAll(".js-free-shampoo .js-free-shampoo-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeShampooTextEls.length; i++){
        // console.log("Updating text...", message);
        freeShampooTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeSoapWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 5000){
        // Add more for free soap:
        progressAmount = 5000 - subtotal;
        progressWidth = (5000 - progressAmount) / 50;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Body Soap</b>.`;              
      } else {
        // Free Soap achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Body Soap!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-soap .progress-bar");
      const freeSoapTextEls = document.querySelectorAll(".js-free-soap .js-free-soap-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeSoapTextEls.length; i++){
        // console.log("Updating text...", message);
        freeSoapTextEls[i].innerHTML = message;
      }
    });
}

function updateFreeTravelCaseWidget(evt){
  // console.log(evt.detail);
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { 
      let progressAmount, progressWidth, message;
      
      let subtotal;
      if (document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1]) {
        subtotal = document.querySelectorAll(".docapp-cart-item.docapp-est-total.docapp-perm .money.geolizr-currency")[1].dataset.geolizrPrice;
      } else {
        subtotal = cart.items_subtotal_price;
      }
      
      if (subtotal < 5000){
        // Add more for free case:
        progressAmount = 5000 - subtotal;
        progressWidth = (5000 - progressAmount) / 50;
        const money = (progressAmount / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
        message = `Spend ${money} for <b>FREE Travel Case</b>.`;              
      } else {
        // Free case achieved!
        progressWidth = 100;
        message = "You'll receive a FREE Travel Case!";
      }

      // Render:
      const progressBarEls = document.querySelectorAll(".js-free-case .progress-bar");
      const freeSoapTextEls = document.querySelectorAll(".js-free-case .js-free-case-text")
      
      for (let i = 0; i < progressBarEls.length; i++){
        // console.log("Updating progress bars...", progressWidth);
        progressBarEls[i].style = "width: " + progressWidth + "%;"
      } 

      for (let i = 0; i < freeSoapTextEls.length; i++){
        // console.log("Updating text...", message);
        freeSoapTextEls[i].innerHTML = message;
      }
    });
}

setTimeout(function(){
  console.log("Updating Progress Widgets")
  updateFreeShippingWidget();
  updateFreeTumblerWidget();
  updateFreeChocolateWidget();
  updateFreeShampooWidget();
  updateFreeSoapWidget();
  updateFreeTravelCaseWidget();
}, 3000)

// End ISH Free Shipping and Tumbler Custom Widgets - Dynamic Update

// ISH Analytics - Product Added
// Segment Analytics commented out - replaced with Customer Events Pixel:

// function analyticsEvent(product){

//   let price_in_dollars = product.price / 100;
  
//   if (typeof analytics == "object")
//     // console.log("Product Added", product);
//     analytics.track('Product Added', {
//         product_id: product.product_id,
//         sku: product.sku,
//         name: product.title,
//         price: price_in_dollars,
//         quantity: product.quantity,
//         category: product.product_type
//     });
    
//     // analytics.identify({
//     //   email: checkout.email
//     // });
//   }
// }

// END ISH Analytics - Product Added


// ISH back-forward cache issue fix: Cart Drawer update if page swiped back
// Works for Android and non-Safari browsers
	
if (!!window.performance && window.performance.navigation.type === 2) {
  // Page was loaded from history (back button or swipe). 
  console.log("Page loaded from history (back button/swipe), refreshing cart...")

  // Refresh cart drawer:
  document.dispatchEvent(new CustomEvent('cart:build'));
}

// END ISH back-forward cache issue fix: Cart Drawer update if page swiped back

// ISH Enable play controls on product videos

const productVideos = document.querySelectorAll(".product__video");
for (let i=0; i < productVideos.length; i++){
  productVideos[i].controls = true;
}

// END ISH Enable play controls on product videos

// ISH Open External Links in new Tab

let links = document.links;
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
  }
}

// END ISH Open External Links in new Tab